import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import TeamTable from "./TeamTable";
import {
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextareaAutosize,
} from "@mui/material";
import DeactivateModal from "../../Common/DeactivateMemberModal";
import axios from "axios";
import {  toast } from "react-toastify";
import { SpinLoader } from "../ImportCandidates";
import ImportCandidates from "../ImportCandidates";
import ArchivedMembers from "./ArchivedMembers";
import { useDispatch, useSelector } from "react-redux";
import RequestedProfile from "./RequestedProfile";
import { VendorProfile as VendorProfileAction } from "../../../Redux/action/VendorProfileAction";

const TeamList = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedReason, setSelectedReason] = useState(""); // To store the selected reason
  const [otherReason, setOtherReason] = useState(""); // To store the custom reason text
  const [showOtherTextarea, setShowOtherTextarea] = useState(
    selectedReason === "other"
  );
  const [loading, setLoading] = useState(false);
  const [componentKey, setComponentKey] = useState(0);
  const [searchValue, setSearchValue] = useState("");

  const queryParams = new URLSearchParams(location?.search);
  const vId = queryParams.get("vendorId");
  const currentTab = queryParams.get("active");

  const [activeTab, setActiveTab] = useState(currentTab ?? "teamMember");
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const baseUrl = process.env.REACT_APP_API_PATH;
  const { userResult } = useSelector((state) => state.Auth);
  let vendorId = vId ? vId : userResult?.vendorid;
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    dispatch(VendorProfileAction(vendorId));
    window.scrollTo(0, 0);
  }, []);

  const handleReasonChange = (event) => {
    const value = event.target.value;
    setSelectedReason(value);

    setShowOtherTextarea(value === "other");
  };

  const handleOtherReasonChange = (event) => {
    setOtherReason(event.target.value);
  };

  const handleSubmit = async (e) => {
    e.stopPropagation();
    if (!selectedReason) {
      return toast.error("Please Select at least one option");
    }
    if (selectedReason === "other" && otherReason.trim() === "") {
      return toast.error("Please give reason in other option");
    }
    setLoading(true);
    try {
      const content = {
        reason: selectedReason !== "other" ? selectedReason : otherReason,
        candidateId: selectedCandidates,
        vendorId,
      };
      const response = await axios.put(
        `${baseUrl}/ebench/deactivate_team_member`,
        content,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.data;
      if (data) {
        toast.success(data.data.body);
      } else {
        toast.error("Something went wrong! please try again.");
      }

      setLoading(false);
      setSelectedReason("");
      setOtherReason("");
      setSelectedCandidates([]);
      closeModal();
      setComponentKey((prevKey) => prevKey + 1);
    } catch (error) {
      setLoading(false);
      console.error("Error occurred", error);
      toast.error(error.response.data.status.message);
    }
  };

  return (
    <>
      {/* <ToastContainer /> */}
      <div key={componentKey}>
        <div>
          {/* <div className="searchCanHead"></div>
                    <div>
                        <div
                            className="d-flex justify-content-around align-items-center g-xl-5 "
                            role="button"
                            style={{
                                textAlign: "center",
                                padding: "20px",
                                marginTop: "0px",
                                gap: "390px"
                            }}
                        >
                            <h2 className="d-flex align-items-center gap-1 " style={{ padding: "5px", }} onClick={() => navigate(-1)} ><BiArrowBack /></h2>
                            <h2 style={{ marginRight: '50px' }}>
                                <b>Team Member List</b>
                            </h2>
                            <h1>{" "}</h1>
                        </div>
                    </div> */}
          <div
            style={{
              maxWidth: window.innerWidth < 640 ? "90%" : "85%",
              display: "flex",
              justifyContent: "space-between",
              margin: "auto",
            }}
          >
            {/* <div className="form-outline">
                            <input
                                type="search"
                                id="form1"
                                className="form-control"
                                placeholder="Search"
                                aria-label="Search"
                                value={searchValue}
                                onChange={(e)=> setSearchValue(e.target.value)}
                            />
                        </div> */}
            <div
              style={{
                marginTop: window.innerWidth < 640 ? "1rem" : "2rem",
                display: "flex",
                flexWrap: "wrap",
                gap: "1rem",
              }}
            >
              {/* <Link to={selectedCandidates.length>0 ? "" :"/import_candidates"} className="pdtn" style={{ color: '#fff', borderRadius:'0px' }}>
                            <Button style={buttonStyles} variant='contained' className={`${selectedCandidates.length > 0 && 'disabled_btn'}`} disabled={selectedCandidates.length > 0}>
                                    <span style={{ color: '#fff' }}>Team Members </span>
                            </Button>
                            </Link> */}
              {/* <Link to={selectedCandidates.length>0 ? "" :"/import_candidates"} className="pdtn" style={{ color: '#fff', borderRadius:'0px' }}>
                            <Button style={buttonStyles} variant='contained' className={`${selectedCandidates.length > 0 && 'disabled_btn'}`} disabled={selectedCandidates.length > 0}>
                                    <span style={{ color: '#fff' }}>Import </span>
                            </Button>
                            </Link> */}
              {/* <Link to={selectedCandidates.length>0 ? "" :"/add-team"} className="pdtn">
                            <Button style={buttonStyles} variant='contained' disabled={selectedCandidates.length > 0} >
                                    <span style={{ color: '#fff' }}>Add </span>
                            </Button>
                            </Link>

                            <Link to={selectedCandidates.length>0 ? "" : "/archived_members"} className="pdtn">
                            <Button style={buttonStyles} variant='contained' disabled={selectedCandidates.length > 0} >
                                    <span style={{ color: '#fff' }}>Archived </span>
                            </Button>
                            </Link> */}

              {/* <div className='common_wrapper mb-4 d-flex justify-content-between align-items-center' style={{fontSize:'14px'}}> */}
              <ul
                style={{ gap: "5px" }}
                className="nav nav-pills justify-content-start"
              >
                {/* {selectedCandidates.length > 0 &&
                                <Button onClick={openModal} style={{ fontSize:'14px',padding: "8px", background: "red",marginInline:"10px",fontFamily:"inherit" }} variant="contained">
                                    Deactivate
                                </Button>
                            } */}
                {/* -----------Team Member------------------------ */}
                <Link
                  to={
                    location.pathname.includes("admin")
                      ? `/admin/team-list?active=teamMember&vendorId=${vId}`
                      : `/team-list?active=teamMember`
                  }
                >
                  <button
                    disabled={selectedCandidates.length > 0}
                    className={`nav-link ${
                      selectedCandidates.length > 0
                        ? "disabled_btn_teamList"
                        : activeTab === "teamMember"
                        ? "active bg_primary color_white"
                        : ""
                    }`}
                    onClick={() => handleTabChange("teamMember")}
                  >
                    Active
                  </button>
                </Link>

                {/* -----------Import------------------------ */}
                {!location.pathname.includes("/admin/team-list") && (
                  <Link
                    to={
                      location.pathname.includes("admin")
                        ? `/admin/team-list?active=import&vendorId=${vId}`
                        : `/team-list?active=import`
                    }
                  >
                    <button
                      disabled={selectedCandidates.length > 0}
                      className={`nav-link ${
                        selectedCandidates.length > 0
                          ? "disabled_btn_teamList"
                          : ""
                      } ${
                        activeTab === "import"
                          ? "active bg_primary color_white"
                          : ""
                      } ${
                        selectedCandidates.length > 0
                          ? "disabled_btn_teamList"
                          : ""
                      }`}
                      onClick={() => handleTabChange("import")}
                    >
                      Import
                    </button>
                  </Link>
                )}

                {/* -----------Archived------------------------ */}

                <Link
                  to={
                    location.pathname.includes("admin")
                      ? `/admin/team-list?active=archived&vendorId=${vId}`
                      : `/team-list?active=archived`
                  }
                >
                  <button
                    disabled={selectedCandidates.length > 0}
                    className={`nav-link ${
                      selectedCandidates.length > 0
                        ? "disabled_btn_teamList"
                        : ""
                    } ${
                      activeTab === "archived"
                        ? "active bg_primary color_white"
                        : ""
                    }`}
                    onClick={() => handleTabChange("archived")}
                  >
                    Closed Account
                  </button>
                </Link>
                {/* -----------Requested Candidates------------------------ */}

                <Link
                  to={
                    location.pathname.includes("admin")
                      ? `/admin/team-list?active=req&vendorId=${vId}`
                      : `/team-list?active=req`
                  }
                >
                  <button
                    disabled={selectedCandidates.length > 0}
                    className={`nav-link  ${
                      selectedCandidates.length > 0
                        ? "disabled_btn_teamList"
                        : ""
                    }  ${
                      activeTab === "req" ? "active bg_primary color_white" : ""
                    }`}
                    onClick={() => handleTabChange("req")}
                  >
                    Requested
                  </button>
                </Link>
              </ul>
              {/* </div> */}
            </div>
          </div>
          <DeactivateModal
            isOpen={isModalOpen}
            onClose={closeModal}
            heading={"Reason for Deactivation"}
          >
            <FormControl fullWidth sx={{ px: 1 }}>
              <FormLabel
                id="demo-radio-buttons-group-label"
                sx={{
                  fontWeight: 600,
                  mb: 1,
                  fontSize: "14px",
                  color: "#0E3F6F",
                }}
              >
                Reasons
                <span style={{ color: "red", marginLeft: 4 }}>*</span>
              </FormLabel>

              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name="radio-buttons-group"
                value={selectedReason}
                onChange={handleReasonChange}
                sx={{ gap: 1 }}
              >
                <FormControlLabel
                  sx={{
                    border: "1px solid #E5E7EB",
                    borderRadius: 2,
                    px: 1.5,
                    py: 0.5,
                    mb: 0.5,
                    alignItems: "flex-start",
                    "& .MuiRadio-root": { pt: "6px" },
                  }}
                  value="Team Member has left their current company"
                  control={<Radio />}
                  label="Team Member has left their current company"
                />

                <FormControlLabel
                  sx={{
                    border: "1px solid #E5E7EB",
                    borderRadius: 2,
                    px: 1.5,
                    py: 0.5,
                    mb: 0.5,
                    alignItems: "flex-start",
                    "& .MuiRadio-root": { pt: "6px" },
                  }}
                  value="The team member requested deactivation due to health or personal circumstances"
                  control={<Radio />}
                  label="The team member requested deactivation due to health or personal circumstances"
                />

                <FormControlLabel
                  sx={{
                    border: "1px solid #E5E7EB",
                    borderRadius: 2,
                    px: 1.5,
                    py: 0.5,
                    mb: 0.5,
                    alignItems: "flex-start",
                    "& .MuiRadio-root": { pt: "6px" },
                  }}
                  value="The candidate's employment was terminated due to policy violations or misconduct"
                  control={<Radio />}
                  label="The candidate's employment was terminated due to policy violations or misconduct"
                />

                <FormControlLabel
                  sx={{
                    border: "1px solid #E5E7EB",
                    borderRadius: 2,
                    px: 1.5,
                    py: 0.5,
                    mb: 0.5,
                    alignItems: "center",
                  }}
                  value="other"
                  control={<Radio />}
                  label="Others"
                />

                {showOtherTextarea && (
                  <TextareaAutosize
                    value={otherReason}
                    onChange={handleOtherReasonChange}
                    placeholder="Other Reason"
                    minRows={5}
                    maxRows={5}
                    style={{
                      width: "100%",
                      marginTop: "10px",
                      padding: "10px",
                      borderRadius: "8px",
                      border: "1px solid #E5E7EB",
                      fontSize: "14px",
                      fontFamily: "inherit",
                      resize: "none",
                    }}
                  />
                )}
              </RadioGroup>

              <div
                style={{
                  marginTop: "24px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  variant="contained"
                  style={{
                    background: "#1c6597",
                    color: "#fff",
                    width: "110px",
                    height: "42px",
                    textTransform: "none",
                    fontWeight: 500,
                  }}
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  {!loading ? "Submit" : <SpinLoader />}
                </Button>
              </div>
            </FormControl>
          </DeactivateModal>

          {activeTab === "teamMember" && (
            <TeamTable
              selectedCandidates={selectedCandidates}
              openModal={() => openModal()}
              setSelectedCandidates={setSelectedCandidates}
              updateTable={handleSubmit}
              search={searchValue}
              setSearch={setSearchValue}
            />
          )}

          {activeTab === "archived" && (
            <ArchivedMembers
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
          )}
          {activeTab === "req" && (
            <RequestedProfile
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
          )}
          {activeTab === "import" &&
            !location.pathname.includes("/admin/team-list") && (
              <ImportCandidates
                activeTab={activeTab}
                setActiveTab={setActiveTab}
              />
            )}
          {/*  {activeTab === "expired" && <ExpiredJobsList posted="EXPIRED" />}
                       {activeTab === "archive" && <ArchiveJobsList posted="" />}
                       {activeTab === "applied" && <AppliedJobsVendor posted="" />} */}
        </div>
      </div>
    </>
  );
};

export default TeamList;
